export const English = {
	'Login with': 'Login with',
	'Unique login': 'Unique login',
	//Sections
	Articles: 'Articles',
	'16k+ library results': '16k+ library results',
	Dictionary: 'Dictionary',
	'More than 20k words from the dictionary':
		'More than 20k words from the dictionary',
	Thesaurus: 'Thesaurus',
	'Thesaurus dictionary': 'Thesaurus dictionary',
	Patents: 'Patents',
	'More than 20k Patent results': 'More than 20k Patent results',
	News: 'News',
	'Recent and relevant global news': 'Recent and relevant global news',
	Media: 'Media',
	'Rich instructional videos': 'Rich instructional videos',
	Books: 'Books',
	Book: 'Book',
	Patent: 'Patent',
	Article: 'Article',
	'16k+ books results': '16k+ books results',
	EBooks: 'EBooks',
	'Spanish Resources': 'Spanish Resources',
	'GALE Resources': 'GALE Resources',
	'Aquino AI': 'Aquino AI',
	'Job Hunter': 'Job Hunter',
	'Interesting Links': 'Interesting Links',
	'Interesting Resources': 'Interesting Resources',
	'Career Development': 'Career Development',
	Tutorials: 'Tutorials',
	'My favorities': 'My favorities',
	Help: 'Help',
	Art: 'Art',
	'More than 10k art stories': 'More than 10k art stories',
	'Library Video': 'Library Video',
	'Learn about Soft Skills and American life':
		'Learn about Soft Skills and American life',
	'Find your favorite content': 'Find your favorite content',
	'More than 2k job offers': 'More than 2k job offers',
	// Home
	'The easiest way to Find': 'The easiest way to Find',
	knowledge: 'knowledge',
	'Search for books, journals, and academic articles':
		'Search for books, journals, and academic articles across hundreds of library databases worldwide. Thanks to our integrated artificial intelligence, you can perform advanced searches that are faster, more accurate, and tailored to your specific needs.',
	'Explore our Library': 'Access to Library',
	'More than': 'More than',
	'sources in just': 'sources in just',
	'one site': 'one site',
	'Your All-in-One': 'Your All-in-One Gateway to Explore Knowledge',
	'Access dictionaries, articles':
		'Access dictionaries, articles, patents, Gale Resources, Job Hunter, and more—all in one place. Explore knowledge with Aquino, our artificial intelligence, and discover reliable resources quickly and intelligently.',
	'Find hundreds of sources searching by topics':
		'Find hundreds of sources searching by topics',
	'Access specialized resources organized':
		'Access specialized resources organized by topic and focused on the university’s academic programs. Easily find the most relevant information for your field of study.',
	'Need help?': 'Need help?',
	"We're here to help you every step of the way":
		"We're here to help you every step of the way.",

	'We understand that while browsing':
		"We understand that while browsing our library or using our resources, questions, technical issues, or even ideas you'd like to share may arise. That's why we have a responsive and accessible support system designed to ensure you never feel alone in the process.",
	'In any library view':
		"In any library view, you'll find an icon with a question mark (?) and the message",
	'Do you have any questions or suggestions?':
		'Do you have any questions or suggestions?',
	'This is your direct access to our support team':
		"This is your direct access to our support team. By clicking on it, you'll be able to create a ticket in seconds. Just tell us briefly what you need, and we'll take care of the rest.",
	'Submit a support request': 'Submit a support request',
	'Learn about our Collection Development Policy':
		'Learn about our Collection Development Policy',

	'In our library, every resource counts':
		"In our library, every resource counts. That's why we follow a Collection Development Policy that guarantees the quality, relevance, and diversity of the content we offer. This document explains the criteria we use to select, evaluate, and update the available materials, always considering the needs of our educational community.",

	"If you'd like to know how we select content":
		"If you'd like to know how we select content, the principles that guide our decisions, and how you can participate with suggestions or comments, we invite you to learn more.",
	'Download the full policy':
		"Download the full policy and discover how we're building a quality library together.",
	'Discover all the': 'Discover all the',
	'scientific news': 'scientific news',
	'Stay up to date with news and updates':
		'Stay up to date with news and updates. Explore our virtual library to expand your knowledge',
	'Your question has a place, and so does our answer':
		'Your question has a place, and so does our answer',
	// NavigationBarResources
	'Main Panel': 'Main Panel',
	'Other Sections': 'Other Sections',
	'One Search': 'One Search',
	'Subject Resources & Databases': 'Subject Resources & Databases',
	'Other Resources': 'Other Resources',
	// NavigationBarModules
	// Footer
	'All rights reserved': 'All rights reserved',
	'Powered by': 'Powered by',
	// Navbar
	'Global News': 'Global News',
	FAQs: 'FAQs',
	// Generics
	nuevo: 'nuevo',
	Consult: 'Consult',
	NEW: 'NEW',
	'View more': 'View more',
	'show more': 'Show more',
	Filter: 'Filter',
	'In Person': 'In Person',
	Remote: 'Remote',
	remote: 'remote',
	'What are you searching?': 'What are you searching?',
	'Show more jobs': 'Show more jobs',
	'Please enter a search term': 'Please enter a search term',
	Filters: 'Filters',
	Sources: 'Sources',
	Year: 'Year',
	Colors: 'Colors',
	'Apply filters': 'Apply filters',
	'Remove all filters': 'Remove all filters',
	Back: 'Back',
	Published: 'Published',
	'Apply for this vacancy here': 'Apply for this vacancy here',
	'Employment summary': 'Wmployment summary',
	'Working time': 'Working time',
	Job: 'Job',
	Workplace: 'Workplace',
	Salary: 'salary',
	more: 'more',
	less: 'less',
	details: 'details',
	View: 'View',
	'No data found': 'No data found',
	'No jobs found':
		'No jobs found. Try adjusting your filters or check back later',
	Next: 'Next',
	Skip: 'Skip',
	'Searched term': 'Searched term',
	results: 'results',
	'Do a search': 'Do a search',
	Search: 'Search',
	'Do a job search': 'Do a job search',
	'Search for topic': 'Search for topic',
	'Search for authors': 'Search for authors',
	English: 'English',
	Spanish: 'Spanish',
	Simple: 'Simple',
	Advance: 'Advance',
	Show: 'Show',
	'Show less art periods': 'Show less art periods',
	'Show all art periods': 'Show all art periods',
	// Instructions
	'Crafting effective search queries':
		'Crafting effective search queries is crucial for information retrieval. Enhance precision by using search equations with logical operators, refining and tailoring queries to align with specific criteria.',
	'To refine your searches you can use': 'To refine your searches you can use',
	'to specify exact matching': 'to specify exact matching',
	'to add logic to to your search': 'to add logic to to your search',
	'to group your search terms': 'to group your search terms',
	// EBooks
	'To view details select the job you are interested in':
		'To view details select the job you are interested in',
	'Welcomem to Olib': 'Welcome to Aquinas Online Library!',
	'Explore our eBooks':
		'Explore our eBooks, now featuring exclusive McGraw Hill titles. Find top-quality resources in management, economics, and more to support your academic journey.',
	'You now have exclusive access to select books':
		'You now have exclusive access to select books from McGraw Hill. Explore titles in management, finance, economics, and more, available to our community.',
	'Go to EBooks': 'Go To EBooks',
	'Click Next': 'Click "Next" to start exploring',
	'Access the best academic resources':
		'Access the best academic resources and enhance your learning. Start discovering today!',
	// Help
	'Aquinas Online Library FAQ': 'Aquinas Online Library FAQ',
	'What is Aquinas Online Library?': 'What is Aquinas Online Library?',
	'What is aquinas online library description':
		'Aquinas Online Library is an online library designed to provide academic content in different formats.',

	'How can I make the most of Aquinas Online Library?':
		'How can I make the most of Aquinas Online Library?',
	'How can I make the most of Aquinas Online Library description':
		"We understand that getting familiar with a new platform can take time. That's why we've created a detailed interactive video to guide you through all the features Aquinas Online Library has to offer.",

	'How can I get the most out of Aquinas Online Library?':
		'How can I get the most out of Aquinas Online Library?',
	'How can I get the most out of Aquinas Online Library description':
		"We understand that getting familiar with a new platform can take time. That's why we've created a detailed interactive video to guide you through all the features Aquinas Online Library has to offer.",

	'How can I find a book from the library?':
		'How can I find a book from the library?',
	'How can I find a book from the library description':
		'You can use the online catalog and request it. If the item is located in another campus library, you can brought it through Interlibrary Loan to this section where the form and procedures are.',
	'How can I make a search to find information for my paper?':
		'How can I make a search to find information for my paper?',
	'How can I make a search to find information for my paper description':
		'There are many resources in Aquinas Online Library that you can use according to the topic you selected. If you are not familiar with your topic it will be good if you start your search using a dictionary. Once you get familiar with the terms it will be easier to find the most relevant resource to start your search.',
	'Are there any guides for writing a paper?':
		'Are there any guides for writing a paper?',
	'You can go to': 'You can go to',
	'Academic Writer': 'Academic Writer',
	'This is a tutorial that provides basic instructions':
		'. This is a tutorial that provides basic instructions on APA Style seventh Edition. Also, you can use Purdue OwL',
	'How can I find a book?': 'How can I find a book?',
	'How can I find a book description':
		'You can find it in the "Books" section, where you can apply filters such as year of publication, edition, author, keyword, and language (English and Spanish).',
	'How can I access the e-books?':
		'How can I access the e-books from the publishing houses partnered with the library?',
	'How can I access the e-books description':
		"In the 'e-books' section, you'll find a specialized integration for these book collections. Here you will find texts specifically selected for the programs of your educational institution.",
	'Can I get support for building my bibliography?':
		'Can I get support for building my bibliography if I’m working on a paper or research?',
	'Can I get support for building my bibliography description':
		'Of course! Our librarian has access to databases and resources to support you. You need to contact them via email at librarian@aquinasnetwork.com or create a help ticket using the help button. Just remember to register the topic you are working on and the scope of your research. They will contact you if they have any questions and share a series of articles that could help you.',
	'What should I do?':
		"What should I do if I can't find a specific reference in the library?",
	'What should I do description':
		'You can email our librarian at librarian@aquinasnetwork.com or create a help ticket using the help button. They will help you find it or suggest others that match your search criteria.',
	'How can I get a citation tool?': 'How can I get a citation tool?',
	// Chat
	'Do you have any question or suggestions?':
		'Do you have any question or suggestions?',
	'Thank you! Your ticket has been successfully created':
		'Thank you! Your ticket has been successfully created.',
	'ticket successfully created description': `We are working on your request and it will be addressed in the next few hours. We’ll get back to you as soon as possible.`,
	'Oops! A problem has occurred': 'Oops! A problem has occurred',
	'A problem has occurred description':
		'Please try submitting your application again.',
	"Need a librarian's advice or is something not working?":
		"Need a librarian's advice or is something not working?",
	"We're here to help!": "We're here to help!",
	Type: 'Type',
	Technician: 'Technician',
	Librarian: 'Librarian',
	Urgency: 'Urgency',
	High: 'High',
	Medium: 'Medium',
	Low: 'Low',
	'Institution name': 'Institution name',
	'Contact information': 'Contact information',
	Phone: 'Phone',
	'Full name': 'Full name',
	Email: 'Email',
	Subject: 'Subject',
	Description: 'Description',
	'Create a ticket': 'Create a ticket',
	// Dictionary
	'Content in this word': 'Content in this word',
	Definition: 'Definition',
	History: 'History',
	Stem: 'Stem',
	'Entries near': 'Entries near',
	Synonyms: 'Synonyms',
	'Related terms': 'Related terms',
	Copy: 'Copy',
	'Generate another response': 'Generate another response',
	'Delete all': 'Delete all',
	Delete: 'Delete',
	'Copy link': 'Copy link',
	'Sign off': 'Sign off',
	'Sign in': 'Sign in',
	'Sign up': 'Sign up',
	'Successfully deleted': 'Successfully deleted.',
	// GALE
	'Go to': 'Go to',
	'Medical description':
		'Access up-to-date and reliable information on nursing, medicine, and health sciences. Ideal for students, researchers, and professionals in the field.',
	'Science description':
		'Access peer-reviewed articles and scientific publications from various disciplines. An essential resource for academic work and scientific exploration.',
	'Human description':
		'Explore the human body with interactive, detailed visual resources. Ideal for students and health sciences professionals.',
	'Gale has joined our collection': 'Gale has joined our collection',
	'with new and valuable resources': 'with new and valuable resources.',
	'We are excited to introduce':
		' We are excited to introduce this addition that will expand your learning and',
	'research opportunities': 'research opportunities',
	'Back to Home': 'Back to Home',
	// AI
	'Go back': 'Go back',
	"Hello! I'm Aquino, your new virtual study partner":
		"Hello! I'm Aquino, your new virtual study partner.",
	'Do you have any questions about a particular topic?':
		'Do you have any questions about a particular topic? Feel free to  ask! To provide you with the best information, I can help you find the most relevant articles in our virtual library.',
	'Please let me know when you would like to switch topics so I can offer you more accurate results':
		'Please let me know when you would like to switch topics so I can offer you more accurate results.',
	'Remember, while I am a powerful tool':
		"Remember, while I am a powerful tool, it's always a good idea to verify my responses with other sources to ensure you have the most comprehensive information. Let's start exploring together!",
	'Make searches in libraries from different sources and topics in  seconds':
		'Make searches in libraries from different sources and topics in  seconds.',
	'Make quick searches in a variety of specialized articles':
		'Make quick searches in a variety of specialized articles.',
	'This assistant can provide automated responses. Always verify key information before making decisions':
		'This assistant can provide automated responses. Always verify key  information before making decisions.',
	'Make searches in libraries from different sources and topics in seconds':
		'Make searches in libraries from different sources and topics in seconds.',
	'Aquino is your artificial intelligence assistant':
		'Aquino is your artificial intelligence assistant designed to conduct quick and efficient searches across a wide variety of sources and specialized articles.',
	'Type your search term here': 'Type your search term here',
	'Here is your answer about': 'Here is your answer about',
	'These are some questions related to this session':
		'These are some questions related to this session',
	'I hope the information has been helpful in your search':
		'I hope the information has been helpful in your search!',
	'This assistant can provide automated responses':
		'This assistant can provide automated responses. Always verify key information before making decisions.',
	// Login Modal
	'Access hundreds of Academic Documents':
		'Access hundreds of Academic Documents',
	'Our platform puts a world of knowledge at your fingertips':
		'Our platform puts a world of knowledge at your fingertips, providing you with the tools and resources you need to succeed in your studies.',
	// Favorite
	'Successfully saved': 'Successfully saved',
	'Find it in your favorites folder': 'Find it in your favorites folder',
	Collections: 'Collections',
	'No favorites yet. Start adding your top picks':
		'No favorites yet. Start adding your top picks!',
	'Yes, delete': 'Yes, delete',
	'No, cancel': 'No, cancel',
	'Are you sure you want to delete this item?':
		'Are you sure you want to delete this item?',
	Favorite: 'Favorite',
	Favorites: 'Favorites',
	// Login
	Return: 'Return',
	'Welcome to': 'Welcome to',
	'Log in': 'Login',
	Login: 'Login',
	'to your account and': 'to your account and',
	'explore our resources': 'explore our resources',
	User: 'User',
	'Email or username': 'Email or username',
	Password: 'Password',

	'Email or username are incorrect': 'Email or username are incorrect.',
	'Need to create an account?': 'Need to create an account?',
	'Forgot your password?': 'Forgot your password?',
	'Happy reading! Welcome to your personalized Virtual Library':
		'Happy reading! Welcome to your personalized Virtual Library. Need help logging in? Your librarian is just an email away at',
	'Check Moodle for the latest updates': 'Check Moodle for the latest updates.',
	// Sign up
	'Create your account': 'Create your account',
	'and access our': 'and access our',
	'exclusive resources': 'exclusive resources.',
	'Error on request. Please try again.': 'Error on request. Please try again.',
	'Your request was successfully processed. Your user credentials will be sent to your email.':
		'Your request was successfully processed. Your user credentials will be sent to your email.',
	'User already exists': 'User already exists',
	'Already have a user account?': 'Already have a user account?',
	// Recover
	'Verify your identity: enter your email to receive your code':
		'Verify your identity: enter your email to receive your code.',
	'Enter the verification code sent to your email':
		'Enter the verification code sent to your email',
	Validate: 'Validate',
	'Receive Code': 'Receive Code',
	'Enter the new password for your account':
		'Enter the new password for your account',
	'Change password': 'Change password',
	'Your new password has been successfully changed. Your new user credentials will be sent to your email':
		'Your new password has been successfully changed. Your new user credentials will be sent to your email.',
	'An error occurred during the process. Please try again':
		'An error occurred during the process. Please try again.',
	'Already have an account?': 'Already have an account?',
	'New password': 'New password',
	Code: 'Code',
	'Authorization code': 'Authorization code',
	'Welcome, select the mode you want to use to login.':
		'Welcome, select the mode you want to use to login.',
	'Full-time': 'Full-time',
	'Part-time and Full-time': 'Part-time and Full-time',
	'Full-time and Part-time': 'Full-time and Part-time',
	'Part-time': 'Part-time',
	Internship: 'Internship',
	'Pediatric phlebotomy': 'Pediatric phlebotomy',
	'Climate change AND renewable energy': 'Climate change AND renewable energy',
	'Artificial intelligence OR machine learning':
		'Artificial intelligence OR machine learning',
	'Smartphones NOT Apple': 'Smartphones NOT Apple',
	'(climate change AND renewable energy) OR (global warming AND sustainable energy)':
		'(climate change AND renewable energy) OR (global warming AND sustainable energy)',
	'Peer reviewed': 'Peer reviewed',
	Keywords: 'Keywords',
	'URL detail': 'URL detail',
	Location: 'Location',
	'Year of work': 'Year of work',
	Link: 'Link',
	Dimensions: 'Dimensions',
	Materials: 'Materials',
	'See more': 'See more',
	Artist: 'Artist',
	'Health Sciences': 'Health Sciences',
	Multidisciplinary: 'Multidisciplinary',
	Education: 'Education',
	'Business Administration': 'Business Administration',
	'Humanities and Social Sciences': 'Humanities and Social Sciences',
	'Technology - Engineering': 'Technology - Engineering',
	'Beauty and wellness': 'Beauty and wellness',
	'Biology, Earth Sciences': 'Biology, Earth Sciences',
	'Do a art search': 'Do a art search',
	'My favorites': 'My favorites',
	'Getting Started': 'Getting Started',
	'with Aquinas Online Library': 'with Aquinas Online Library',
	'Learn to use OLIB with these two interactive videos':
		'Learn to use OLIB with these two interactive videos, available in English and Spanish. These are the only tutorials you need to navigate the platform, search for resources, and customize your experience efficiently.',
	'Make the most of OLIB and enhance your learning experience':
		'Make the most of OLIB and enhance your learning experience.',
	'New Resources': 'New Resources',
	Close: 'Close',
	Topic: 'Topic',
	Language: 'Language',
	Welcome: 'Welcome!',
	'Use your': 'Use your',
	Wordpress: 'Wordpress',
	'username and password to': 'username and password to',
	'continue on': 'continue on',
	Olib: 'Aquinas Online Library',
	'Username or Email Address': 'Username or Email Address',
	'Login with Wordpress': 'Login with Wordpress',
	'Enter your': 'Enter your',
	'username and password in the fields to log in and access all features':
		'username/email and password in the fields to log in and access all features',
	'Connection failed, try again later.': 'Connection failed, try again later.',
	'Invalid credentials': 'Invalid credentials',
	'Username or Email Address is required':
		'Username or Email Address is required',
	'Password is required': 'Password is required',
	'Explore all resources': 'Explore all resources',
	'your virtual study partner': 'Your virtual study partner',
	'optimize your learning':
		'Optimize your learning with Aquino AI, the intelligent tool designed to help you explore virtual libraries, find specialized articles, and resolve academic questions in seconds. Obtain accurate and structured information to enhance your research and strengthen your knowledge efficiently.',
	explore: 'Explore',
	'new releases notice board':
		'Aquinas Online Library New Releases Notice Board',
	"We couldn't complete your sign in": "We couldn't complete your sign in",
	'Google authentication failed. Please try again.':
		'Google authentication failed. Please try again.',
	'This Google account domain is not allowed for this institution.':
		'This Google account domain is not allowed for this institution.',
	'Close Google login error modal': 'Close Google login error modal',
};
